<div
  [clickOutsideExclude]="
    '.organization-list, .add-to-favorite-modal, .actions-dropdown-menu, .more-actions-btn'
  "
  (clickOutside)="onClickOutsideDropdown($event)"
>
  <div
    ngbDropdown
    class="community-space-dropdown dropdown-no-arrow"
    container="body"
    [autoClose]="false"
    dropdownClass="organization-list"
    placement="bottom-end"
  >
    <div
      ngbDropdownToggle
      class="d-flex flex-column align-items-center pointer-cursor"
      [ngbTooltip]="'StartPage.NavItem.Spaces' | translate"
      [disableTooltip]="!isMobile"
    >
      <ng-icon
        name="matFormatListBulletedOutline"
        class="dropdown-toggle-icon"
      ></ng-icon>

      <span
        class="py-1 font-size-sm d-none d-md-flex align-items-center justify-content-center"
        >{{ 'StartPage.NavItem.Spaces' | translate }}
        <ng-icon
          name="matArrowDropDownOutline"
          size="1rem"
          class="ms-1"
        ></ng-icon
      ></span>
    </div>

    <div
      ngbDropdownMenu
      [style.width.px]="280"
    >
      <app-community-selector
        [isDropdownMode]="true"
        (orgSelected)="communitySpaceDropdown()?.close()"
      />
    </div>
  </div>
</div>
